/*!
 * @license
 * Copyright © 2005-2025 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { DateAlfresco } from '../../content-custom-api';

export class DirectAccessUrl {
    /**
     * The direct access URL of a binary content
     */
    contentUrl: string;
    /**
     * Whether or not the content downloads as an attachment
     */
    attachment?: boolean;
    /**
     * The direct access URL would become invalid when the expiry date is reached
     */
    expiryTime?: Date;

    constructor(input?: Partial<DirectAccessUrl>) {
        if (input) {
            Object.assign(this, input);
            this.expiryTime = input.expiryTime ? DateAlfresco.parseDate(input.expiryTime) : undefined;
        }
    }

}
